import script from "./formulaMeaning.vue?vue&type=script&setup=true&lang=js"
export * from "./formulaMeaning.vue?vue&type=script&setup=true&lang=js"

import "./formulaMeaning.vue?vue&type=style&index=0&id=aa26f8e6&lang=scss"

const __exports__ = script;

export default __exports__